export const createPassword = async (
  password: string,
  token: string,
  language: string
) => {
  const data = await fetch(`/api/auth/create-password`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      password,
      token,
      language,
    }),
  })

  return data.status
}
